import { useEffect } from 'react';
import { Button, Box, Typography, Alert, Collapse, Paper } from '@mui/material';
import { Lock } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const COGNITO_ON =
  (window.__AUTH_PROVIDER__ || process.env.REACT_APP_AUTH_PROVIDER || 'local') === 'cognito';

export default function Login() {
  const { startCognito, error } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();



 const handleSubmit = (e) => {
  e.preventDefault();
  // Local email/password flow removed — use the buttons below.
};
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
      <Paper elevation={4} sx={{ width: 400, p: 4 }}>
        <Typography variant="h5" gutterBottom align="center">Login</Typography>

        <Collapse in={!!error}>
          <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
        </Collapse>

        <Box>
          <Button
            type="button"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 1 }}
            startIcon={<Lock />}
            onClick={(e) => { e.preventDefault(); const r = startCognito('login'); console.log('[AUTH] startCognito returned', r); }}
          >
            Sign in with Cognito
          </Button>

          <Button
            variant="outlined"
            fullWidth
            sx={{ mt: 2 }}
            onClick={() => startCognito('signup')}
          >
            Create account
          </Button>
        </Box>

      </Paper>
    </Box>
  );
}
